/* eslint-disable */
import React from 'react';
import ReactDOM from 'react-dom';
import Root from 'Root';
import { i18n } from 'element-react'
import locale from 'element-react/src/locale/lang/ko'

i18n.use(locale);

import 'styles/main.scss';
import 'element-theme-default';
import 'lib/localCart';

// import registerServiceWorker from './registerServiceWorker';

const render = window.__REDUX_STATE__ ? ReactDOM.hydrate : ReactDOM.render;
const isDev = process.env.NODE_ENV === 'development' || process.env.MODE_ENV === 'staging';

if (typeof window !== 'undefined') {
  render(<Root />, document.getElementById('root'));
}
// registerServiceWorker();

// GTM Load
(function(w, d, s, l, i) {
  w[l] = w[l] || [];
  w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var f = d.getElementsByTagName(s)[0],
    j = d.createElement(s),
    dl = l != 'dataLayer' ? '&l=' + l : '';
  j.async = true;
  j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
  f.parentNode.insertBefore(j, f);
})(window, document, 'script', 'dataLayer', 'GTM-KJXF37L');

var Tawk_API=Tawk_API||{}, Tawk_LoadStart=new Date();
(function(){
  var s1=document.createElement("script"),s0=document.getElementsByTagName("script")[0];
  s1.async=true;
  s1.src='https://embed.tawk.to/686cacb0c449c7190f6f404c/1ivk854nk';
  s1.charset='UTF-8';
  s1.setAttribute('crossorigin','*');
  s0.parentNode.insertBefore(s1,s0);
})();



// WEBPACK FOOTER //
// ./src/index.js